export default "__VITE_ASSET__CPPY7pRC__"